@if (coordinator.showBackdrop()) {
  <div animate.enter="backdrop-show" animate.leave="backdrop-hide" class="backdrop"></div>
}
